import styled from 'styled-components'

const DEFAULT_FONT_FAMILY = 'Poppins, sans-serif'

export const DEFAULT_FONT_COLOR = '#01404E'

const B1_FONT_SIZE = '16px'
const B1_FONT_WEIGHT = '700'
const B1_LINE_HEIGHT = '26px'

const B3_FONT_SIZE = '14px'
const B3_FONT_WEIGHT = '700'
const B3_LINE_HEIGHT = '20px'

const B4_FONT_SIZE = '12px'
const B4_FONT_WEIGHT = '700'
const B4_LINE_HEIGHT = '14px'

const BaseText = styled.div`
  font-family: var(--sc-widget-font-family, ${DEFAULT_FONT_FAMILY});
  text-align: left;
`

export const Body1 = styled(BaseText)`
  font-size: ${B1_FONT_SIZE};
  font-weight: ${B1_FONT_WEIGHT};
  line-height: ${B1_LINE_HEIGHT};
  color: ${DEFAULT_FONT_COLOR};
`

export const Body3 = styled(BaseText)`
  font-size: ${B3_FONT_SIZE};
  font-weight: ${B3_FONT_WEIGHT};
  line-height: ${B3_LINE_HEIGHT};
  color: ${DEFAULT_FONT_COLOR};
`

export const Body4 = styled(BaseText)`
  font-size: ${B4_FONT_SIZE};
  font-weight: ${B4_FONT_WEIGHT};
  line-height: ${B4_LINE_HEIGHT};
  color: ${DEFAULT_FONT_COLOR};
`
